import React, { ReactElement, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Divider, Paper } from '@mui/material'
import Grid from '@mui/material/Grid'
import { StackedBarChartOutlined } from '@mui/icons-material'
import { useAppId } from 'src/app/AppProvider'
import { useTranslate } from 'src/i18n/useMessageSource'
import { getEnumFromString } from 'src/service/utils/CommonUtils'
import { Hidden } from 'src/ui-shared/base/hidden/Hidden'
import { StyledTab } from 'src/ui-shared/base/tab-panel/StyledTab'
import { StyledTabs } from 'src/ui-shared/base/tab-panel/StyledTabs'
import { TabPanel } from 'src/ui-shared/base/tab-panel/TabPanel'
import { useSharedStyles } from 'src/ui-shared/constants/Shared.style'
import { InsertChartOutlinedIcon } from 'src/ui-shared/icons/Icons'
import { ScreenLayout } from 'src/ui/layout/main-layout/ScreenLayout'
import { ConsumptionCostChart } from 'src/ui/page/sm/consumption/list/ConsumptionCostChart'
import { ConsumptionTab } from 'src/ui/page/sm/consumption/list/ConsumptionTab'
import { ConsumptionTotalsChart } from 'src/ui/page/sm/consumption/list/ConsumptionTotalsChart'

export const ConsumptionListPage = (): ReactElement => {
  const translate = useTranslate()
  const { classes: sharedClasses } = useSharedStyles()

  const navigate = useNavigate()
  const appId = useAppId()

  const { tabNameParam } = useParams()
  const tabName = tabNameParam ? getEnumFromString(tabNameParam, ConsumptionTab) : ConsumptionTab.TOTALS

  const [activeTab, setActiveTab] = useState<ConsumptionTab>(ConsumptionTab.TOTALS)

  useEffect(() => {
    setActiveTab(tabName)
  }, [])

  // handle events
  const handleTabChange = (event: React.SyntheticEvent, newValue: ConsumptionTab) => {
    const pathToNavigate = `/${appId}/consumption/view/${newValue}`
    navigate(pathToNavigate, { replace: true })
    setActiveTab(newValue)
  }

  return (
    <ScreenLayout title={translate('consumption')} actionsWidth={30}>
      <Paper elevation={0}>
        <Grid container className={sharedClasses.TabsContainer}>
          <Grid size={{ lg: 6, md: 12, sm: 12, xs: 12 }}>
            <StyledTabs
              value={activeTab}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              onChange={handleTabChange}
            >
              <StyledTab
                icon={<InsertChartOutlinedIcon />}
                iconPosition={'start'}
                value={ConsumptionTab.TOTALS}
                label={<Hidden down="md">{translate('totals')}</Hidden>}
              />
              <StyledTab
                icon={<StackedBarChartOutlined />}
                iconPosition={'start'}
                value={ConsumptionTab.COST}
                label={<Hidden down="md">{translate('cost')}</Hidden>}
              />
            </StyledTabs>
          </Grid>
        </Grid>
        <Divider />
        <TabPanel value={activeTab} index={ConsumptionTab.TOTALS}>
          <ConsumptionTotalsChart />
        </TabPanel>
        <TabPanel value={activeTab} index={ConsumptionTab.COST}>
          <ConsumptionCostChart />
        </TabPanel>
      </Paper>
    </ScreenLayout>
  )
}
